import React, { useState, useEffect, useContext, useCallback, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';
import localization from 'assets/localization/localization';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from "../../../../assets/images/imageData";
import ListFilters from 'components/sales/ListFilters/ListFilters';
import { Button } from "react-bootstrap";

const ViewQuotations = ({
  match,
  getAllQuotations,
  allQuotations,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [listData, setListData] = useState();
  const [showFilter, setShowFilter] = useState(false);
  const [filterData, setFilterData] = useState(null);

  const Headers = [
    'Project Id',
    'Client Name',
    'Solution Type',
    'AMC Cost',
    'Server Charge',
    'Status',
    'Created At',
    'Updated At',
    'Action',
  ];

  useEffect(() => {
    (async () => {
      setIsLoading(true)
      await getAllQuotations(0)
      setIsLoading(false)
    })()
  }, [])

  useEffect(() => {
    const tableData = [
      'infra_project_id',
      'client_name',
      'solution_type',
      'amc_cost',
      'server_charge',
      'status',
      'created_at',
      'updated_at'
    ];
    if (
      allQuotations &&
      allQuotations.length > 0
    ) {
      const data = allQuotations.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({
            [key]: element[key],
          }
          )),
          {
            Action: [
              {
                name: 'View Quotation',
                link: `${baseUrl}/project-onboarding/view-quotation/${element.quotation_id}`,
              }]
          }
        )
      );
      data && setListData(data);
    }
  }, [allQuotations]);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (filterData) => {
    setIsLoading(true);
    setFilterData(filterData);
    setListData([])
    await getAllQuotations(0, filterData)
    setIsLoading(false);
    filterToggle();
  };

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={filterToggle}
          className="filter-hamburger show-btn btn btn-transparent"
        >
          {' '}
          <img src={Images?.Filter} alt="" />
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };


  return (
    <Layout
      title="Quotations Listing"
      isLoading={isLoading}
      Buttons={headerBtns}
    >
      <TableSection
        data={listData}
        headers={Headers}
      />
      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        quotationFilter={true}
      />
    </Layout>
  );
};

export default ViewQuotations;
